import React, { useState, useRef, useCallback } from 'react';
import { tradeLicenseApi } from '../../services/tradeLicenseApi';

/**
 * Bilingual input: type English, auto-fill Hindi on blur/debounce.
 */
const BilingualInput = ({
  label,
  enName,
  hiName,
  enValue,
  hiValue,
  onChange,
  type = 'text',
  required = false,
  rows = 3,
  placeholderEn = '',
  placeholderHi = '',
  multiline = false,
  fieldContext = 'general',
}) => {
  const [translating, setTranslating] = useState(false);
  const timerRef = useRef(null);

  const translateToHindi = useCallback(async (text) => {
    if (!text || !text.trim()) return;
    setTranslating(true);
    try {
      const response = await tradeLicenseApi.translateText(text.trim(), { field_context: fieldContext });
      const translated = response.data.translated || '';
      if (translated) {
        onChange({ target: { name: hiName, value: translated } });
      }
    } catch (err) {
      console.error('Translation failed:', err);
    } finally {
      setTranslating(false);
    }
  }, [hiName, onChange, fieldContext]);

  const handleEnglishChange = (e) => {
    onChange(e);
    const value = e.target.value;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (value.trim()) translateToHindi(value);
    }, 800);
  };

  const handleEnglishBlur = (e) => {
    if (!hiValue && e.target.value.trim()) {
      translateToHindi(e.target.value);
    }
  };

  const InputComponent = multiline ? 'textarea' : 'input';

  return (
    <div className="bilingual-field-group">
      <div className="form-group">
        <label>
          {label} (English) {required && '*'}
          {translating && <span className="translating-badge"> Translating…</span>}
        </label>
        <InputComponent
          type={multiline ? undefined : type}
          name={enName}
          value={enValue}
          onChange={handleEnglishChange}
          onBlur={handleEnglishBlur}
          required={required}
          placeholder={placeholderEn}
          rows={multiline ? rows : undefined}
        />
      </div>
      <div className="form-group">
        <label>{label} (Hindi) {required && '*'}</label>
        <InputComponent
          type={multiline ? undefined : type}
          name={hiName}
          value={hiValue}
          onChange={onChange}
          placeholder={placeholderHi}
          rows={multiline ? rows : undefined}
        />
      </div>
    </div>
  );
};

export default BilingualInput;
